import { atom } from 'recoil';
import type { PlaceDetails } from '@app/shared/state/user-added-stops.atom';

// Places saved by user
export const atom_savedPlaces = atom<PlaceDetails[]>({
    key: 'savedPlaces',
    default: [],
});

// Currently selected place in search
export const atom_selectedPlace = atom<PlaceDetails | null>({
    key: 'selectedPlace',
    default: null,
});
